import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const loginUser = createAsyncThunk('auth/loginUser', async (credentials, thunkAPI) => {
    try {
        const { email, password } = credentials;
        if (email === 'admin@example.com' && password === 'admin') {
            return { token: 'admin-token', user: { role: 'admin', name: 'Admin User' } };
        } else if (email === 'acc@example.com' && password === 'acc') {
            return { token: 'acc-token', user: { role: 'accountant', name: 'Accountant User' } };
        }
        const repsJson = localStorage.getItem('representatives_json');
        if (repsJson) {
            const reps = JSON.parse(repsJson);
            const rep = reps.find(r => (r.email === email || r.username === email) && r.password === password);
            if (rep) {
                return { token: 'rep-token', user: { ...rep, role: 'representative' } };
            }
        }
        return thunkAPI.rejectWithValue('Invalid credentials'); 
    } catch (error) {
        return thunkAPI.rejectWithValue('Login failed');
    }
});

const storedUser = JSON.parse(localStorage.getItem('user'));
const storedToken = localStorage.getItem('token');


const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: storedUser || null,
        token: storedToken || null,
        loading: false,
        error: null,
    },
    reducers: {
        logout: (state) => {
            state.user = null;
            state.token = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loginUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loginUser.fulfilled, (state, action) => {
                state.loading = false;
                state.token = action.payload.token;
                state.user = action.payload.user;
                localStorage.setItem('token', action.payload.token);
                localStorage.setItem('user', JSON.stringify(action.payload.user));
            })
            .addCase(loginUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(logout, (state) => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                state.user = null;
                state.token = null;
            });
    },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;